import React from 'react';
import Typing from 'react-typing-animation';

const IntroBanner = () => {
    return (
        <div>
            <article className="mt-16">
                <Typing startDelay="2000">
                    <p className="text-gray-600 font-mono text-center mt-4 text-2xl text-space tracking-wide">I Write Code to Make Life Easier</p>
                </Typing>
                <hr className="mt-8 w-3/5 mx-auto" />
            </article>
            <section className="space-y-10 md:pt-8 text-left md:space-y-0 md:mx-32 my-16 grid md:grid-cols-2 grid-cols-1 ">
                <div data-aos="zoom-in" className="flex items-center justify-center  md:border-r-2">
                    <div id="introduction" className="md:mr-16 p-4 text-center md:text-left">
                        <h1 className="text-3xl mb-8 font-semibold text-gray-600">Kamil Hassan</h1>
                        <p className="tracking-wide text-gray-600">I am a reliable Web Developer with a flair for creating elegant solutions in the least amount of time and passion for removing redundancy by writing reusable code. Over the last couple of months, I have acquired some skills to become a high performer in this role. I think my biggest strength is learning new and hard technologies faster which will provide value to myself and to the company I am working for.</p>
                    </div>
                </div>
                <div data-aos="zoom-in" id="skills" className="mx-auto grid grid-cols-3 gap-4 md:gap-8 md:ml-16 p-4 md:p-0">
                    <div
                        className="w-28 h-28 text-xs bg-gray-600 border-8 border-indigo-500 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Team Work
                    </div>
                    <div
                        className="animate-pulse w-28 h-28 text-xs bg-gray-600 border-8 border-pink-600 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Writing
                    </div>
                    <div
                        className=" w-28 h-28 text-xs p-2 text-center bg-gray-600 border-8 border-purple-500 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Problem Solving
                    </div>
                    <div
                        className="animate-pulse w-28 h-28 text-xs bg-gray-600 border-8 border-green-500 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Leadership
                    </div>
                    <div
                        className=" w-28 h-28 text-xs bg-gray-600 border-8 border-yellow-500 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Hard Working
                    </div>
                    <div
                        className="animate-pulse w-28 h-28 text-xs bg-gray-600 border-8 border-red-400 text-white rounded-full flex justify-center items-center font-light tracking-wide">
                        Fast Learner
                    </div>
                </div>
            </section>
        </div>
    );
};

export default IntroBanner;